<!-- 库存分拣 -->
<template>
<el-dialog :title="msg('库存分拣')" :visible.sync="visible" 
    :fullscreen="isMinScreen"  :close-on-click-modal="false"  width="600px"
>
<el-form label-width="100px">
    <el-row>
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('单号')">
                <el-input v-model="code" ref="codeRef" placeholder="请输入库存单号、子单号、入仓码" size="small" @keyup.native="autoSelectCode">
                </el-input>
            </el-form-item>
            <input style="display:none"/>
        </el-col>
        <el-col :xs="24" :sm="6">
            <template>
                <el-checkbox style="margin-left:10px;margin-top:8px" v-model="discard">弃件</el-checkbox>
            </template>
        </el-col>
    </el-row>
  
    <div style="text-align:center;margin-top:10px;">
        <el-button  size="mini" type="danger" v-on:click="visible=false;">{{msg('关闭')}}</el-button>
    </div>

    <!-- <div style="display:inline-block; width:1px; height:1px; overflow:hidden;">
        <audio controls="controls" preload ref="audioRef" >
        </audio>
    </div> -->
    <div style="display:inline-block; width:1px; height:1px; overflow:hidden;">
        <audio controls="controls" preload ref="audioRef" @ended="endPlay">
        </audio>
    </div>
</el-form> 
</el-dialog>
</template>

<script>
import noCode from "../../assets/media/noInCode.mp3";//单号不存在
import save from "../../assets/media/save.mp3";//保留
import qijian from "../../assets/media/qijian.mp3";//弃件
import qijianSuccess from "../../assets/media/qijianSuccess.mp3";//弃件
import zhuanji from "../../assets/media/zhuanji.mp3";//转寄件
import jihui from "../../assets/media/jihui.mp3";//寄回件
import notUpper from "../../assets/media/notUpper.mp3";//未上架
import PlayWeight from "../../components/PlayWeight";
export default {
    name: 'ExpressSorting',
    data(){
        return{
            visible: false,
            code:null,
            audioUrl:null,
            urls:[noCode,save,qijian,zhuanji,jihui,notUpper,qijianSuccess],
            discard:false,
            playWeight: null,
            playList: [],  //播放列表
            playStatus: false,
            playPosition: null,//当前播放位置
        }
    }, 
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
    },
    methods:{
        showDialog(){
            this.visible = true;
            this.code = null;
            this.discard = false;
            // 初始化语音播报功能
            this.playWeight = new PlayWeight();
            this.playList = [];
            this.playStatus = false;
            this.playPosition = null;
        },
        autoSelectCode(e){
            if(e.keyCode == 13){
                this.expSort();
            }

        },
        expSort(){
            if(!this.code){
                this.$message(this.msg('请输入订单编号、面单码、查询码'));
                return;
            }  
            let dis = 0;
            if(this.discard){
                dis = 1;
            }
            this.$axios.get(this.$kit.api.inventory.sorting
                +"?code="+this.code
                +"&discard="+dis
            ).then((result) =>{
                if(result.status){
                    // this.playAudio(result.data);
                    let data = result.data;
                    this.playList.push(this.urls[data-1])
                    this.code = null;
                    this.$refs['codeRef'].focus();
                    if(this.discard && data != 1){
                        // this.playAudio(6);
                        this.playList.push(this.urls[6])
                    }
                    this.playAudio();
                }else{
                    this.$message(result.msg);
                }
            
            });
        },
        // playAudio(index){
        //     let audio = this.$refs.audioRef;
        //     audio.src = this.urls[index-1];
        //     audio.play();
        // },
        endPlay(){
            if(this.playPosition >= this.playList.length){
                this.playPosition = 0;
                this.playList = [];
                this.playStatus = false;
            }else{
                this.playAudio();
            }
        },
        playAudio(){
            this.playStatus = true;
            let audio = this.$refs.audioRef;
            let media = this.playList[this.playPosition++];
            if(media){
                audio.src = media;
                audio.play();
            }else{
                this.endPlay();
            }
        },
    }
}
</script>

<style scoped lang="scss">


</style>
